import { Box, Stack, TextField } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';
import { CrudPage } from '../../shared/components/CrudPage';
import { resources } from '../../core/services/resources';
import type { Tag } from '../../core/types/data-models';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 80 },
  { field: 'name', headerName: 'Name', flex: 1, minWidth: 220 },
  {
    field: 'color',
    headerName: 'Color',
    width: 140,
    renderCell: (p) =>
      p.value ? (
        <Stack direction="row" alignItems="center" spacing={1} sx={{ height: '100%' }}>
          <Box
            sx={{
              width: 14,
              height: 14,
              borderRadius: 0.5,
              border: '1px solid',
              borderColor: 'divider',
              backgroundColor: p.value as string,
            }}
          />
          <span>{p.value as string}</span>
        </Stack>
      ) : null,
  },
];

export function TagsPage() {
  return (
    <CrudPage<Tag>
      title="Tags"
      entityName="Tag"
      description="Global tag catalog. Tags are not tenant-scoped — they're shared across every tenant."
      cacheKey={['tags']}
      service={resources.tags}
      columns={columns}
      defaultValues={{ name: '', color: '#1f6feb' }}
      renderForm={({ values, setValues }) => (
        <Stack spacing={2}>
          <TextField
            label="Name"
            required
            value={values.name ?? ''}
            onChange={(e) => setValues({ ...values, name: e.target.value })}
          />
          <TextField
            label="Color"
            type="color"
            value={values.color ?? '#1f6feb'}
            onChange={(e) => setValues({ ...values, color: e.target.value })}
          />
        </Stack>
      )}
    />
  );
}
